import { useState, useEffect } from 'react';
import "./FormResponsesTableSettings.css";
import Modal from "../shared/Modal";
import { Form, Question, UpdateHiddenQuestionsPayload } from 'effno-core';
import { FormQuestion } from '../form-question/FormQuestion';
import { apiUpdateHiddenQuestions } from '../../services/FormService';
import { toastFail, toastSuccess } from '../../config';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { selectUser } from '../../redux/features/appData';
import { MySwitch } from '../form-widgets/MySwitch';

type FormResponsesTableSettingsProps = {
    isOpen: boolean;
    form: Form;
    questions: Question[];
    hiddenQuestionIds: string[];
    onClose: () => void;
    onSubmit: (questionIds: string[]) => void;
}

// NR note that selecting something means 

export const FormResponsesTableSettings = ({
    isOpen,
    form,
    questions,
    hiddenQuestionIds,
    onClose,
    onSubmit
    }: FormResponsesTableSettingsProps) => {

    const storeUser = useSelector(selectUser);
    
    const [newHiddenQuestionIds, setNewHiddenQuestionIds] = useState<string[]>(hiddenQuestionIds);
    const [changes, setChanges] = useState<boolean>(false);

    useEffect(() => {
        if (isOpen) {
            setNewHiddenQuestionIds([]);
        }
    }, [isOpen]);

    useEffect(() => {
        setNewHiddenQuestionIds(hiddenQuestionIds);
    }, [hiddenQuestionIds]);

    const handleSave = async () => {
        const payload : UpdateHiddenQuestionsPayload = {
            formId: form.id, 
            userId: storeUser?.id || "",
            hiddenQuestionIds: newHiddenQuestionIds
        }

        console.log("[FormResponsesTableSettings] handleSave payload: ", payload);
        // return;

        const updatedRecord = await apiUpdateHiddenQuestions(payload);

        if (!updatedRecord) {
            toast("Error updating hidden questions", toastFail);
            return;
        }

        toast("Updated", toastSuccess);
        onSubmit(newHiddenQuestionIds);
    }

    console.log("[FormResponsesTableSettings] newHiddenIds: ", newHiddenQuestionIds);

    return (
        <Modal
            isOpen={isOpen}
            style={null}
            onClose={onClose}
            canClose={true}
            allowClickout={true}
        >
            <div className="table-settings">
               
                <div className="table-settings-title">
                    Table Settings
                </div>

                <div className="table-settings-questions">
                    {questions.map((question, index) => (
                        <div 
                            key={question.id}
                            className="table-settings-question"
                        >
                            <FormQuestion 
                                question={question}
                                allowMenu={false}
                            />

                            <div className="table-settings-checkbox">
                                <MySwitch
                                    checked={!newHiddenQuestionIds.includes(question.id)}
                                    onChange={(checked) => {
                                        if (!checked) {
                                            setNewHiddenQuestionIds([...newHiddenQuestionIds, question.id]);
                                        } else {
                                            setNewHiddenQuestionIds(newHiddenQuestionIds.filter((id) => id !== question.id));
                                        }

                                        setChanges(true);
                                    }}
                                />

                                {/* <input
                                    type="checkbox"
                                    checked={newHiddenQuestionIds.includes(question.id)}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setNewHiddenQuestionIds([...newHiddenQuestionIds, question.id]);
                                        } else {
                                            setNewHiddenQuestionIds(newHiddenQuestionIds.filter((id) => id !== question.id));
                                        }

                                        setChanges(true);
                                    }}
                                /> */}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="modal-buttons">
                    <button 
                        className="button-cancel"
                        onClick={onClose}
                        data-testid="cancel-settings"
                    > 
                        Cancel 
                    </button>
                    <button 
                        disabled={!changes }
                        onClick={handleSave}
                        data-testid="apply-settings"
                    >
                        Apply 
                    </button>
                </div>
                
            </div>
      </Modal>
    )
}